<template>
  <div class="w-full h-[200px] relative">

    <!-- Google Map -->
    <GoogleMap
        :api-key="api_key"
        style="width: 100%; height: 200px"
        :center="center"
        :zoom="15"
        @click="onMapClick"
    >
      <Marker :options="{ position: center, draggable: true }" @dragend="onMarkerDrag" />
    </GoogleMap>
  </div>
</template>

<script>
import { GoogleMap, Marker } from 'vue3-google-map';

export default {
  name: 'GoogleMapComponent',
  components: { GoogleMap, Marker },
  props: {
    activeBranch: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true, // Track loading state
      center: { lat: 0, lng: 0 }, // Default value before activeBranch loads
      api_key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY
    };
  },
  watch: {
    activeBranch: {
      immediate: true, // Ensure the watcher runs on component mount
      handler(newValue) {
        if (newValue && newValue.lat && newValue.long) {
          this.center = {
            lat: Number(newValue.lat),
            lng: Number(newValue.long)
          };
        }
      }
    }
  },
  methods: {
    mapLoaded() {
      this.loading = false; // Hide loading once tiles are loaded
    },
    onMarkerDrag(event) {
      // Get new lat/lng from marker event
      this.center = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };
      this.$emit('handleAddress', {lat: event.latLng.lat(), lng: event.latLng.lng()});
    },

    onMapClick(event) {
      // Get lat/lng where the user clicked on the map
      this.center = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };
      this.$emit('handleAddress', {lat: event.latLng.lat(), lng: event.latLng.lng()});
    }
  }
};
</script>

<style>
/* Optional: Add some nice loading UI */
</style>
